var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BookView container-fluid"},[_c('BookMap',{staticClass:"full-width Map-container",style:(("height: calc(100% - " + (_vm.propsNavBar.height) + ")"))}),_c('RouterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }